module.exports = __webpack_public_path__ + "static/joyful_5-0c584a37985a4536e30f73a5def4bdfb.jpg";